import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_BASE } from "../../config/api";
export default function VerifyAccount() {
  const [message, setMessage] = useState("Verifizierung läuft...");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setMessage("Token missing!");
      return;
    }

    fetch(API_BASE+`/api/account-verification/verify?token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setMessage(data.message);
          setTimeout(() => navigate("/login"), 2000);
        } else {
          setMessage(data.message || "Verification failed");
        }
      })
      .catch(err => {
        console.error(err);
        setMessage("Verification failed");
      });
  }, [token, navigate]);

  return <div>{message}</div>;
}